module.exports = __webpack_public_path__ + "static/media/up.bea45403.svg";